import { Button, Space, Tag, Typography } from 'antd';
import React from 'react';
import { SubsectionRendering } from './SubsectionRendering';
import { ISubsectionWidgetComponentProps } from './SubsectionWidgetComponent';
import { SubsectionPreviewContainer } from './style/SubsectionPreviewContainer';
const { Title, Text } = Typography;

export function SubsectionWidgetPreview(
  props: ISubsectionWidgetComponentProps,
) {
  const { widget } = props;

  return (
    <SubsectionPreviewContainer>
      {widget.rendering === SubsectionRendering.Drawer ? (
        <Button>{widget.placeholder ?? 'Apri'}</Button>
      ) : (
        <div>
          {widget.rendering === SubsectionRendering.Inline ? (
            <Space direction="horizontal" align="center">
              <Tag color="blue">Codice: {widget.code ?? 'Sottosezione'}</Tag>
              <Tag color="blue">IN LINEA</Tag>
            </Space>
          ) : (
            <Space direction="horizontal" align="center">
              <Tag color="red">Codice: {widget.code ?? 'Sottosezione'}</Tag>
              <Tag color="red">NASCOSTA</Tag>
            </Space>
          )}
        </div>
      )}
    </SubsectionPreviewContainer>
  );
}
